import React from 'react';
import {View} from 'react-native';
import {Props} from './model';
import {Modal} from '../../../../shared/components/modal/modal';
import {useStyles} from '../../../../shared/hooks/styles';
import {SurveyCongratsMessage} from '../surveyCongratsMessage';

export default ({onClose}: Props) => {
  const styles = useStyles(() => ({
    modalWrap: {
      paddingVertical: 0,
      paddingHorizontal: 0,
    },
    modalTitle: {display: 'none'},
    contentWrapper: {
      paddingHorizontal: 135,
      paddingTop: 80,
      paddingBottom: 127,
    },
    modalContent: {
      paddingTop: 0,
    },
  }));
  return (
    <Modal
      contentStyle={styles.modalContent}
      wrapStyle={styles.modalWrap}
      titleStyle={styles.modalTitle}
      onClose={onClose}>
      <View style={styles.contentWrapper}>
        <SurveyCongratsMessage />
      </View>
    </Modal>
  );
};
